<template>
  <div
    :class="[
      'BaseColumn',
      {
        'BaseColumn--1/1': cols === 1,
        'BaseColumn--1/2': cols === 2,
        'BaseColumn--1/3': cols === 3,
        'BaseColumn--1/4': cols === 4
      }
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="postcss">
.BaseColumn,
.swiper-slide.BaseColumn {
  @apply w-full;

  @screen md {
    @apply space-x-sm;
    --column-gutter: theme('spacing.sm');
    
    &--1\/2 {
      width: calc((100% - 1 * var(--column-gutter)) / 2);
    }

    &--1\/3 {
      width: calc((100% - 2 * var(--column-gutter)) / 3);
    }

    &--1\/4 {
      width: calc((100% - 3 * var(--column-gutter)) / 4);
    }
  }
}
</style>
